import {
  createAsyncThunk,
  createSlice,
  appLogout,
  injectSlice,
  persistReducer,
} from '@bonanza-social/toolkit/state';
import { AsyncStorage } from '@bonanza-social/toolkit/storage';
import { CashbackState } from './cashback.types';
import CashbackService from '../../services/CashbackService/CashbackService';

const initialState: CashbackState = {
  data: [],
  dataState: 'idle',
};

export const fetchCashback = createAsyncThunk(
  'cashback/fetch',
  async () => await CashbackService.getCashback(),
);

const cashback = createSlice({
  name: 'cashback',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(fetchCashback.pending, (state) => {
      state.dataState =
        state.dataState === 'fulfilled' ? 'refreshing' : 'pending';
    });

    builder.addCase(fetchCashback.fulfilled, (state, { payload }) => {
      state.dataState = 'fulfilled';
      state.data = payload.promotions.sort(
        (a, b) => new Date(b.endDate).getTime() - new Date(a.endDate).getTime(),
      );
    });

    builder.addCase(fetchCashback.rejected, (state) => {
      state.dataState = 'rejected';
    });

    builder.addCase(appLogout, (state) => {
      Object.assign(state, initialState);
    });
  },
});

const persistConfig = {
  key: 'cashback',
  storage: AsyncStorage,
  whitelist: ['data'],
};

const persistedReducer = persistReducer(persistConfig, cashback.reducer);

export const withCashback = injectSlice({
  reducerPath: 'cashback',
  reducer: persistedReducer,
});

export const selectCashbacks = withCashback.selector(
  (state) => state.cashback.data,
);

export const selectCashbacksDataState = withCashback.selector(
  (state) => state.cashback.dataState,
);

declare global {
  interface LazyLoadedSlices {
    status: ReturnType<typeof persistedReducer>;
  }
}
